(function () {
  'use strict';

  var launcher = document.getElementById('budget-bot-launcher');
  var panel = document.getElementById('budget-bot');
  var closeButton = document.getElementById('budget-bot-close');
  var messages = document.getElementById('budget-bot-messages');
  var form = document.getElementById('budget-bot-form');
  var budgetInput = document.getElementById('budget-bot-budget');
  var dataNode = document.getElementById('BudgetBotProducts');
  if (!launcher || !panel || !messages || !form || !budgetInput || !dataNode) return;

  var products = [];
  var selectedBudget = 0;
  var selectedProject = '';
  try { products = JSON.parse(dataNode.textContent || '[]'); } catch (error) { return; }

  var projectOptions = [
    { id: 'beginner', label: 'Beginner learning', words: 'starter beginner arduino kit breadboard sensor' },
    { id: 'robot', label: 'Robot / car', words: 'robot motor driver wheel chassis ultrasonic servo' },
    { id: 'iot', label: 'WiFi / IoT', words: 'esp32 esp8266 wifi iot relay sensor' },
    { id: 'sensor', label: 'Sensor project', words: 'sensor ultrasonic pir dht ldr relay' }
  ];

  function money(value) {
    return '₹' + Math.round(value).toLocaleString('en-IN');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function addMessage(html, type) {
    var message = document.createElement('div');
    message.className = 'budget-bot-message ' + (type || 'bot');
    message.innerHTML = html;
    messages.appendChild(message);
    messages.scrollTop = messages.scrollHeight;
    return message;
  }

  function showWelcome() {
    messages.innerHTML = '';
    addMessage('<strong>Hi! I am your project helper.</strong><br>Tell me your budget and I will suggest components, a possible kit, and a project idea.', 'bot');
    addMessage('<div class="budget-bot-chips"><button type="button" data-budget="500">₹500</button><button type="button" data-budget="1000">₹1,000</button><button type="button" data-budget="1500">₹1,500</button><button type="button" data-budget="2500">₹2,500</button></div>', 'bot');
  }

  function setOpen(open) {
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', String(!open));
    launcher.setAttribute('aria-expanded', String(open));
    if (open && !messages.children.length) showWelcome();
    if (open) setTimeout(function () { budgetInput.focus(); }, 100);
  }

  function chooseBudget(value) {
    var budget = Number(String(value).replace(/[^0-9]/g, ''));
    if (!budget || budget < 100) {
      addMessage('Please enter a budget of at least ₹100.', 'bot');
      return;
    }
    selectedBudget = budget;
    addMessage('My budget is ' + money(budget) + '.', 'user');
    addMessage('Great! What would you like to build?', 'bot');
    addMessage('<div class="budget-bot-chips">' + projectOptions.map(function (option) {
      return '<button type="button" data-project="' + option.id + '">' + option.label + '</button>';
    }).join('') + '</div>', 'bot');
  }

  function rankProduct(product, project) {
    var terms = (product.title + ' ' + product.tags + ' ' + product.type).toLowerCase();
    var score = 0;
    project.words.split(' ').forEach(function (word) { if (terms.indexOf(word) !== -1) score += 3; });
    if (/kit|starter/.test((product.title + ' ' + product.tags).toLowerCase())) score += 4;
    if (product.price <= selectedBudget * 0.5) score += 1;
    return score;
  }

  function buildCombo(budget, project) {
    var candidates = products.filter(function (product) { return product.available && product.price > 0 && product.price <= budget; })
      .map(function (product) { return { product: product, score: rankProduct(product, project) }; })
      .sort(function (a, b) { return b.score - a.score || a.product.price - b.product.price; });
    // Search all short combinations rather than picking the first two matches.
    // Relevance is prioritised, then the combo that uses the budget best wins.
    var relevant = candidates.filter(function (entry) { return entry.score > 0; });
    var pool = (relevant.length ? relevant : candidates).slice(0, 18);
    var best = { items: [], total: 0, value: -1 };

    function consider(items, total, score) {
      if (!items.length) return;
      var value = score * 100 + (total / budget) * 25 + Math.min(items.length, 3);
      if (value > best.value || (value === best.value && total > best.total)) {
        best = { items: items.slice(), total: total, value: value };
      }
    }

    function findCombinations(start, items, total, score) {
      consider(items, total, score);
      if (items.length === 4) return;
      for (var index = start; index < pool.length; index += 1) {
        var entry = pool[index];
        if (total + entry.product.price > budget) continue;
        items.push(entry.product);
        findCombinations(index + 1, items, total + entry.product.price, score + entry.score);
        items.pop();
      }
    }

    findCombinations(0, [], 0, 0);
    return best;
  }

  function projectCopy(project) {
    return {
      beginner: 'an LED, buzzer, or sensor-based learning project',
      robot: 'an obstacle-avoiding robot or smart car',
      iot: 'a WiFi smart-home project or remote sensor monitor',
      sensor: 'a distance, motion, or environment monitor'
    }[project.id] || 'starter electronics project';
  }

  function showRecommendation() {
    var project = projectOptions.filter(function (option) { return option.id === selectedProject; })[0] || projectOptions[0];
    var combo = buildCombo(selectedBudget, project);
    addMessage('For <strong>' + escapeHtml(project.label) + '</strong>, here is my recommendation within ' + money(selectedBudget) + ':', 'bot');
    if (!combo.items.length) {
      addMessage('I could not find an available product within this budget. Please try a slightly higher budget.', 'bot');
      return;
    }
    var list = combo.items.map(function (item) {
      return '<li><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a><span>' + money(item.price) + '</span></li>';
    }).join('');
    addMessage('<div class="budget-bot-kit"><p><strong>Suggested starter combo · ' + money(combo.total) + '</strong></p><ul>' + list + '</ul><p class="budget-bot-project">You can start <strong>' + projectCopy(project) + '</strong> with these parts.</p><button type="button" class="btn-primary" data-add-combo="' + combo.items.map(function (item) { return item.variantId; }).join(',') + '">Add this combo to cart</button><button type="button" data-restart style="width:100%;margin-top:8px;border:0;background:transparent;color:var(--muted);font:600 12px var(--font-body);text-decoration:underline;cursor:pointer">Do not like it? Start again</button></div>', 'bot');
    showUpgrade(project, combo);
  }

  function showUpgrade(project, combo) {
    var upgrades = [100, 200].map(function (extra) {
      var better = buildCombo(selectedBudget + extra, project);
      return { extra: extra, combo: better };
    }).filter(function (upgrade) { return upgrade.combo.total > combo.total; });
    if (!upgrades.length) return;
    var best = upgrades[0];
    addMessage('<div class="budget-bot-upgrade"><strong>Could you add a little more?</strong><br>With just ' + money(best.extra) + ' extra, you can get a better ' + money(best.combo.total) + ' combo.<br><button type="button" data-upgrade="' + best.extra + '">Show the better ' + money(best.extra) + ' option</button></div>', 'bot');
  }

  async function addCombo(ids, button) {
    var items = ids.split(',').filter(Boolean).map(function (id) { return { id: id, quantity: 1 }; });
    if (!items.length) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      var response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!response.ok) throw new Error('Unable to add this combo.');
      button.textContent = 'Added to cart ✓';
      document.getElementById('cart-btn').click();
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try adding again';
      addMessage(error.message || 'This combo could not be added to your cart. Please try again.', 'bot');
    }
  }

  launcher.addEventListener('click', function () { setOpen(!panel.classList.contains('is-open')); });
  closeButton.addEventListener('click', function () { setOpen(false); });
  form.addEventListener('submit', function (event) { event.preventDefault(); chooseBudget(budgetInput.value); });
  messages.addEventListener('click', function (event) {
    var budgetButton = event.target.closest('[data-budget]');
    var projectButton = event.target.closest('[data-project]');
    var upgradeButton = event.target.closest('[data-upgrade]');
    var cartButton = event.target.closest('[data-add-combo]');
    var restartButton = event.target.closest('[data-restart]');
    if (budgetButton) chooseBudget(budgetButton.dataset.budget);
    if (projectButton) { selectedProject = projectButton.dataset.project; addMessage('I would like to build: ' + projectButton.textContent + '.', 'user'); showRecommendation(); }
    if (upgradeButton) { selectedBudget += Number(upgradeButton.dataset.upgrade); addMessage('Yes, I can add ' + money(upgradeButton.dataset.upgrade) + ' more.', 'user'); showRecommendation(); }
    if (cartButton) addCombo(cartButton.dataset.addCombo, cartButton);
    if (restartButton) { selectedBudget = 0; selectedProject = ''; showWelcome(); budgetInput.value = ''; budgetInput.focus(); }
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') setOpen(false); });
}());
